<div class="gutter">
	<header #header class="flx-col flx-gap-default">
		<h1 #headerTitle>{{ (page | async).name }}</h1>
	</header>
	<div class="flx-dynamic flx-cntr-strtch flx-gap-default">
		<div class="w-50 flx-col flx-cntr-strtch content">
			<img class="hero" *ngIf="(page | async).extra_field_1" [src]="cdn+'/pages/'+(page | async).photos_directory+'/'+(page | async).extra_field_1">
			<app-ve *ngIf="(page | async).content" [content]="(page | async).content"></app-ve>
		</div>
		<div class="contact-form-wrap flx-dynamic-50 flx-col flx-gap-default">
	
			<form [formGroup]="form" (submit)="submit()" novalidate class="flx-col flx-gap-default">
	
				<h4 i18n="@@sf_title1">Twoje dane do kontaktu</h4>
				<div class="flx-dynamic flx-gap-default">
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@name">Imię</mat-label>
						<input matInput formControlName="name">
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@surname">Nazwisko</mat-label>
						<input matInput formControlName="surname" >
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@email">Adres e-mail</mat-label>
						<input matInput formControlName="email" >
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
				</div>
	
				<h4 i18n="@@sf_title2">Twój adres</h4>
				<div class="flx-dynamic flx-gap-default">
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@cmpn_name">Nazwa firmy</mat-label>
						<input matInput formControlName="company">
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
	
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@phone">Telefon</mat-label>
						<input matInput formControlName="phone" >
						<mat-error  i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
				</div>
	
				<div class="flx-dynamic flx-gap-default">
	
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@street">Ulica</mat-label>
						<input matInput formControlName="street">
						<mat-error  i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
	
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@building">Nr. domu</mat-label>
						<input matInput formControlName="building">
						<mat-error  i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
	
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@house">Nr. mieszkania</mat-label>
						<input matInput formControlName="flat">
					</mat-form-field>
				</div>
	
				<div class="flx-dynamic flx-gap-default w-100">
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@city">Miejscowość</mat-label>
						<input matInput formControlName="city">
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@postcode">Kod pocztowy</mat-label>
						<input matInput formControlName="postcode">
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@country">Kraj</mat-label>
						<mat-select formControlName="country">
							<mat-option *ngFor="let country of countries" [value]="country.value">
								{{ country.viewValue }}
							</mat-option>
						</mat-select>
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
				</div>
	
				<h4 i18n="@@sf_title3">Informacje o przyczepie</h4>
				<div class="flx-dynamic flx-gap-default w-100">
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@vin_cnt">VIN (numer nadwozia) przyczepy</mat-label>
						<input matInput formControlName="extra_1">
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<mat-form-field appearance="outline" class="flx-grw">
						<mat-label i18n="@@datepurchase">Data zakupu</mat-label>
						<input matInput formControlName="extra_2">
						<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
				</div>
	
	
				<div id="uploader" class="flx-col flx-gap-default flx-strt-strtch">
	
					<p class="infobox success" *ngIf="(uploaded | async).length > 0">
						<ng-container i18n="@@filesadded">Następujące pliki zostały dodane do zgłoszenia</ng-container>:<br>
						<span *ngFor="let item of (uploaded | async)">{{ item }}<br></span>
					</p>
					
					<p class="infobox error" *ngIf="(errored | async).length > 0">
						<ng-container i18n>Następujące pliki nie zostały dodane do zgłoszenia, wystąpił nieoczekiwany błąd</ng-container>:<br>
						<span *ngFor="let item of (errored | async)">{{ item.name }} {{ item.error }}<br></span>
						<ng-container i18n>Spróbuj jeszcze raz.</ng-container>
					</p>
	
					<div *ngIf="(uploaded | async).length == 0" ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (onFileDrop)="fileDropped($event)"  [uploader]="uploader" class="drop-zone flx-col flx-cntr-cntr">
						<div *ngIf="loading_file | async" class="loader-circle"></div>
						<div *ngIf="!(loading_file | async)">
							<span i18n="@@addinvoice">DODAJ FAKTURĘ ZAKUPU PRZECIĄGAJĄC JĄ TUTAJ LUB </span> <label class="fileselect" for="file" i18n="@@selectdrv">WYBIERZ Z DYSKU</label><input id="file" class="inputfile" type="file" ng2FileSelect (onFileSelected)="fileDropped($event)" [uploader]="uploader" multiple>
						</div>
					</div>


					<mat-error style="margin: 4px 8px;"  *ngIf="(uploaded | async).length == 0 && form.controls.rodo.dirty" i18n="@@error_req">To pole jest wymagane</mat-error>
					
				</div>
	
				<label class="switch rodo w-100 mb">
						<input #checkbox type="checkbox" formControlName="rodo">
						<span class="switch-style"></span>
						<span class="switch-txt">{{ (page | async).extra_field_4 }} <a [routerLink]="['/'+path_rules]" i18n="@@reg_here">Regulamin dostępny jest tutaj.</a></span>
						<mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n="@@rodoerror">Musisz wyrazić zgodę na przetwarzenie swoich danych osobowych.</mat-error>
				</label>
	
				<label class="switch rodo w-100 mb">
					<input #checkbox type="checkbox" formControlName="rodo1">
					<span class="switch-style"></span>
					<span class="switch-txt">{{ (page | async).extra_field_5 }}</span>
					<mat-error *ngIf="form.controls.rodo1.invalid && form.controls.rodo1.dirty" i18n="@@rodoerror">Musisz wyrazić zgodę na przetwarzenie swoich danych osobowych.</mat-error>
				</label>
	
				<p class="infobox error" *ngIf="result === 'error'" >{{ resultMessage }}</p>
				<div class="form-success" *ngIf="result === 'success' && (sent | async)" >
					<h1 i18n="@@simplethanks">Dziękujemy za wysłanie formularza</h1>
					<p i18n="@@simpletext">Prosimy o potwierdzenie rejestracji klikając link w otrzymanej wiadomości e-mail.</p>
				</div>
	
				<div class="flx-row flx-strt-cntr flx-gap-default mt">
					<button class="flat-button primary fat" (click)="submit()"  [disabled]="(sent | async) || (loading | async)" i18n="@@send">Wyślij wiadomość</button>
					<div *ngIf="loading | async" class="loader-circle"></div>
				</div>	
			</form>
	
		</div>
	</div>
	</div>